import { useMemo } from 'react';
import { SelectFieldOption } from 'components/DropDown/ValidatingSelect';
import { useDeviceReps } from 'api/hooks/useDeviceReps';

type Props = { supplierId?: string; enabled?: boolean };

const useSupplierRepSelectOptions = ({ supplierId, enabled = true }: Props) => {
  const loadDeviceReps = !!(enabled && supplierId);

  const { data: deviceReps } = useDeviceReps(
    {
      supplier: supplierId,
      limit: '-1',
    },
    loadDeviceReps,
  );

  // need a reliable isLoading to maintain isLoadingInitial
  const isLoading = loadDeviceReps && !deviceReps;

  const supplierRepOptions = useMemo<SelectFieldOption[]>(() => {
    return (
      deviceReps?.deviceReps.map(deviceRep => ({
        id: deviceRep.id,
        label: deviceRep.name + (deviceRep.specialty?.length ? ` (${deviceRep.specialty.join(', ')})` : ''),
      })) || []
    );
  }, [deviceReps]);

  return { supplierRepOptions, isLoading };
};

export default useSupplierRepSelectOptions;
